import Stage2Player1Room from "../shared/Stage2Player1Room";

export default function Six_Players_Stage2_Player1(props) {
  return <Stage2Player1Room {...props} playerCount={6} />;
}